import { useQuery } from "@apollo/client/react";
import { useHasFeature } from "@/auth/access-features";
import { FEATURE_CATALOG } from "@/auth/feature-catalog";
import { ListingMembershipDocument } from "@/graphql/generated/operations";

/**
 * Ob die Person die Verwaltung einer Ausschreibung (ihr Dashboard) nutzen darf: `share.listings` und an ihr
 * eingetragen, dasselbe Mitgliedssignal wie im Dashboard (`access != null`). Ohne das Feature fragt der Hook
 * nicht, genesis antwortete mit einem Fehler. Auf der Vorschau aus dem Dashboard steht die Zugriffsliste
 * schon im Cache (ListingDetail), dort geht keine weitere Anfrage hinaus.
 */
export function useCanManageListing(listingId: string): boolean {
  const feature = useHasFeature(FEATURE_CATALOG.shareListings.key);
  const { data } = useQuery(ListingMembershipDocument, {
    variables: { id: listingId },
    skip: !feature || !listingId,
  });
  return feature && data?.listing?.access != null;
}
